import axios from './axiosInstance';


export const getAllEvents = () => {
  return axios.get('/events');
};

export const getEventWorkmenList = (filter) => {
  return axios.get('/event/workmen-list', { params: { ...filter } });
};

//send -invite
export const sendInvite = (data) => {
  return axios.post('/send-invite', data);
};

export const getWorkmanById = (id) => {
  return axios.get(`/workman/${id}`);
};

export const updateWorkmanProfile = (payload) => {
  return axios.post('/workman/update', payload);
};

export const fetchLocationDetails = (zip) => {
  return axios.get(`/location/${zip}`);
};

export const saveBatch = async (payload) => {
  return axios.post("/batch", payload);
};

export const updateBatch = async (payload) => {
  return axios.put("/batch", payload);
};

export const getBatchSuggestions = async (payload) => {
  return axios.get("/batches/suggestions", { params: payload });
};

export const getBatchesListData = async (payload) => {
  return axios.get("/batches/all", { params: payload });
};

export const getBatch = async (batchId, punches) => {
  return axios.get(`/batch/${batchId}`, {
    params: { punches },
  });
};

export const fieldAutoSuggest = (payload) => {
  return axios.post('/autoSuggest', payload);
};

export const getEmployeeDetails = (employeeId) => {
  return axios.get(`/employee/${employeeId}`);
}

export const exportBatchToKronos = (payload) => {
  return axios.post('/batch/submit-to-kronos', payload);
}

export const getBranches = () => {
  return axios.get('/branches');
};